import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'

interface ResetQuotaDialogProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: () => void
}

export default function ResetQuotaDialog({
	isOpen,
	onClose,
	onConfirm,
}: ResetQuotaDialogProps) {
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>ยืนยันการรีเซ็ตโควต้า</DialogTitle>
					<DialogDescription>
						คุณต้องการรีเซ็ตโควต้าทั้งหมดใช่หรือไม่?
						การดำเนินการนี้ไม่สามารถย้อนกลับได้
						<br />
						(การรีเซ็ตโควต้าจะทำให้โควต้าของ users บนเว็บทั้งหมดเหลือ 0)
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="flex gap-2 pt-4">
					<Button variant="outline" onClick={onClose}>
						ยกเลิก
					</Button>
					<Button variant="destructive" onClick={onConfirm}>
						ยืนยัน
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
